// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WB6W","index":"styles_index__8fW0l"};